import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['sidebar'];

  open() {
    this.sidebarTarget.classList.remove('hidden');
    document.body.classList.add('overflow-hidden');
  }
  close() {
    this.sidebarTarget.classList.add('hidden');
    document.body.classList.remove('overflow-hidden');
  }
}
